"use strict";

var _toConsumableArray = require("/agent/_work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var idna_uts46_hx_1 = __importDefault(require("idna-uts46-hx"));

function toCurrency(amount) {
  var showCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var value = amount.toLocaleString("en-AU", {
    maximumFractionDigits: showCents ? 2 : 0,
    minimumFractionDigits: showCents ? 2 : 0
  });
  return amount < 0 ? "-$".concat(value.slice(1)) : "$".concat(value);
}

exports.toCurrency = toCurrency;

function isDefined(value) {
  return value !== undefined && value !== null;
}

exports.isDefined = isDefined;

exports.amountAllowedValidator = function (min, max) {
  return createValidator(function (amount) {
    return +amount >= min && +amount <= max;
  }, "Loan amount must be between ".concat(toCurrency(min, false), " and ").concat(toCurrency(max, false)));
};

exports.wholeDollarAmountValidator = createValidator(function (val) {
  return /^[0-9]*$/.test(val);
}, "Please enter a whole dollar amount, without cents");
exports.currencyValidator = createValidator(function (val) {
  return /^\d*(\.\d{0,2})?$/.test(val);
}, "Please enter a valid amount");

function isValidEmail(email) {
  if (!email) {
    return false;
  }

  try {
    email = email.replace(/(@)(.+)$/i, function (_match, _p1, p2) {
      var idn = idna_uts46_hx_1.default.toAscii(p2);
      return "@".concat(idn);
    });
  } catch (e) {
    return false;
  }

  var quotedEmail = /^((".+?"@))((\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-z][-0-9a-z]*[0-9a-z]*\.)+[a-z0-9][\-a-z0-9]{0,22}[a-z0-9]))$/i;
  var escapedQuote = /\\"@/i;
  var standardEmail = /^((([0-9a-z_]((\.(?!\.))|[-!#\$%&'\*\+/=\?\^`\{\}\|~\w])*)@))((\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-z][-0-9a-z]*[0-9a-z]*\.)+[a-z0-9][\-a-z0-9]{0,22}[a-z0-9]))$/i;
  var plainCharacterBeforeAt = /([0-9a-z_])@/i;
  return standardEmail.test(email) && plainCharacterBeforeAt.test(email) || quotedEmail.test(email) && !escapedQuote.test(email);
}

exports.isValidEmail = isValidEmail;

function createValidator(predicate, msg) {
  return function (val) {
    return predicate(val) || msg;
  };
}

exports.createValidator = createValidator;

function combineValidators(val) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return args.reduce(function (acc, curr) {
    return acc === true ? curr(val) : acc;
  }, true);
}

exports.combineValidators = combineValidators;

exports.classFormat = function (text) {
  return text.replace(/[^a-zA-Z0-9\s_-]/g, "").toLowerCase().split(" ").join("-");
};

exports.capitalise = function (text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

exports.toRate = function (value) {
  return isNaN(value) ? "" : "".concat(value.toFixed(2), "%");
};

exports.monthsToYears = function (months, yearsOnly) {
  var yearsNumber = Math.floor(months / 12);
  var monthsNumber = months % 12;
  return yearsOnly ? "".concat(yearsNumber, "+ years") : "".concat(yearsNumber, " ").concat(yearsNumber === 1 ? "year" : "years", " and ").concat(monthsNumber, " ").concat(monthsNumber === 1 ? "month" : "months");
};

exports.mergeArrays = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  // Once we support node 11 we can use array.flat instead
  return _toConsumableArray(args.reduce(function (acc, val) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(val));
  }));
};

exports.isNotEmpty = function (object) {
  return object != null && Object.keys(object).length !== 0;
};

exports.isBrowser = function () {
  return typeof window !== "undefined";
};

var DESKTOP_WIDTH = 992;
var TABLET_WIDTH = 768;

var windowWidth = function windowWidth() {
  return exports.isBrowser() && window.innerWidth || DESKTOP_WIDTH;
};

exports.isBrowserMobile = function () {
  return windowWidth() < TABLET_WIDTH;
};

exports.isBrowserTablet = function () {
  return windowWidth() >= TABLET_WIDTH && windowWidth() < DESKTOP_WIDTH;
};

exports.isBrowserDesktop = function () {
  return windowWidth() >= DESKTOP_WIDTH;
};